import { gql } from '@apollo/client';

export const GET_SERVICE_CATEGORIES_FOR_PROPCOMP = gql`
query {
  serviceCategories {
    id
    name
    text
    image
    colour
    sortId
    selectable
  }
}
`;
